import React from 'react';
import './index.less'

export class AppMaskLayer extends React.Component<{tips?:string}> {
  render() {
    return (
      <div className="app-mask-layer">
        <div className='app-mask-layer-bg'>
          <span className="app-mask-layer-dot">
            <i className="app-mask-layer-dot-item"></i>
            <i className="app-mask-layer-dot-item"></i>
            <i className="app-mask-layer-dot-item"></i>
            <i className="app-mask-layer-dot-item"></i>
          </span>
          <p style={{ transform: 'translateX(-20%)' }}>{this.props.tips||'loading'}</p>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/qcc/AppMaskLayer/index.tsx